const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withBundleLoading = require("../../core/hoc/withBundleLoading");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const {atCart, atParentAccount} = require("../../core/vault/StateCursors");
const URLMake = require("../../../shared/URLMake");
const OpsUser = require("../../core/vault/OpsUser");
const AT = require("../../core/vault/ActionTypes");
const MultiLoadGuard = require("../../core/view/MultiLoadGuard");
const InitRenderSwitch = require("../../core/view/InitRenderSwitch");
const LoadingCircle = require("../../core/view/LoadingCircle");
const RedeemSubscriptionCode = require("./RedeemSubscriptionCode");
const RedeemSubscriptionAccount = require("./RedeemSubscriptionAccount");
const RedeemSubscriptionStudentsLoggedOut = require("./RedeemSubscriptionStudentsLoggedOut");
const RedeemSubscriptionStudentsLoggedIn = require("./RedeemSubscriptionStudentsLoggedIn");
const RedeemSubscriptionReview = require("./RedeemSubscriptionReview");
const RedeemSubscriptionConfirmation = require("./RedeemSubscriptionConfirmation");
const _ = require("lodash");
const {ArrowLeft} = require("lucide-react");

const styles = require("./styles/PageRedeemSubscription.css");

const DEFAULT_STEPS = [
	"code",
	"account",
	"studentsLoggedOut",
	"review",
	"confirmation",
];
const PARENT_STEPS = ["studentsLoggedIn", "review", "confirmation"];

const PLATFORM_GUEST_STEPS = [
	"code",
	"studentsLoggedOut",
	"review",
	"confirmation",
];

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		cart: atCart(vaultState).get(),
		account: atParentAccount(vaultState).get(),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageRedeemSubscription",

		propTypes: {
			user: PT.object.isRequired,
			step: PT.string,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			cart: PT.object.isRequired,
			account: PT.object,
			dispatch: PT.func.isRequired,
			requireOrLoadBundle: PT.func.isRequired,
		},

		getDefaultProps: function() {
			return {step: "code"};
		},

		getInitialState: function() {
			const isParent = OpsUser.hasParentRole(this.props.user);
			const isPlatformGuest = OpsUser.isPlatformGuest(this.props.user);
			const notParentSteps = isPlatformGuest
				? PLATFORM_GUEST_STEPS
				: DEFAULT_STEPS;
			const steps = isParent ? PARENT_STEPS : notParentSteps;
			return {
				codeSuccessfullyUsed: false,
				steps: steps,
			};
		},

		// Used by vault update HOC
		vaultEvents: {
			redeemSubscriptionCodesSuccess: function() {
				this.setState({codeSuccessfullyUsed: true});
				this.props.setNextScrollTo("top");
				this.removeAutofillDataFromVault();
				this.nextSection();
			},
			// Happens on logout
			resetVaultState: function(user) {
				this.onUserChange(user);
			},
			// Happens on login
			loadUserSuccess: function(user) {
				this.onUserChange(user);
			},
		},

		removeAutofillDataFromVault: function() {
			const oldStudentData = _.get(
				this.props.cart,
				"redeemSubscriptionStudentData",
				{}
			);
			const updatedStudentData = {
				...oldStudentData,
				isNewStudent: false,
				isSelected: false,
			};
			this.props.dispatch({
				type: AT.UPDATE_REDEEM_CODES_STUDENT_DATA,
				studentData: updatedStudentData,
				code: "",
			});
		},

		componentDidMount: function() {
			// Needed to update the parent when codes are redeemed
			// and set up the account in the vault.
			this.props.requireOrLoadBundle("parent");
		},

		componentDidUpdate: function(prevProps) {
			if (this.props.step !== prevProps.step) {
				this.props.setNextScrollTo("top");
			}
		},

		// Something here to load the parent's account when they've authenticated
		loadParentAccount: function() {
			this.props.dispatch({
				type: AT.LOAD_PARENT_ACCOUNT_REQUEST,
			});
		},

		// Fire this when the user logs in or out, sending them back to
		// the first step in the flow.
		onUserChange: function(user) {
			const isParent = OpsUser.hasParentRole(user);
			const isPlatformGuest = OpsUser.isPlatformGuest(user);
			const notParentSteps = isPlatformGuest
				? PLATFORM_GUEST_STEPS
				: DEFAULT_STEPS;
			const steps = isParent ? PARENT_STEPS : notParentSteps;
			this.setState({steps: steps});
			// don't restart flow if we've already gone through
			if (!this.state.codeSuccessfullyUsed) {
				this.restartFlow();
			}
		},

		setSection: function(newSection) {
			if (newSection !== this.props.step) {
				this.props.dispatch({
					type: AT.SET_PAGE,
					pageState: URLMake.state.forRedeemSubscriptionStep(newSection),
					addToHistory: true,
				});
			}
		},

		previousSection: function() {
			const {step} = this.props;
			const {steps} = this.state;
			const currIndex = steps.indexOf(step);
			if (currIndex < steps.length && currIndex > 0) {
				this.setSection(steps[currIndex - 1]);
			} else {
				this.setSection(steps[0]);
			}
		},

		nextSection: function() {
			const {step} = this.props;
			const {steps} = this.state;
			const currIndex = steps.indexOf(step);
			if (currIndex < steps.length - 1 && currIndex > -1) {
				this.setSection(steps[currIndex + 1]);
			} else {
				this.setSection(steps[0]);
			}
		},

		getSignInText: function(email, username) {
			if (email) return `as ${email}, which is not a Parent Account`;
			if (username) return `as ${username}, which is not a Parent Account`;
			return `to an account that is not a Parent Account`;
		},

		restartFlow: function() {
			// Not strictly necessary, but it's a good idea to clear the student data
			// when the flow is restarted.
			this.props.dispatch({
				type: AT.UPDATE_REDEEM_CODES_STUDENT_DATA,
				studentData: {},
			});
			this.setState({codeSuccessfullyUsed: false});
			this.setSection(this.state.steps[0]);
			this.props.setNextScrollTo("top");
		},

		switchToParent: function() {
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				logoutPage: "/signin",
			});
		},

		renderNonParentContent: function() {
			const email = _.get(this.props.user, "model.email");
			const username = _.get(this.props.user, "model.username");
			const isStudent = OpsUser.isStudent(this.props.user);
			return (
				<div className={styles.sectionWrapper}>
					<h2 className={styles.title}>
						Sign into your Parent Account to use your subscription code
					</h2>
					<div className={styles.bodyText}>
						You are signed in {this.getSignInText(email, username)}. In order to
						use a subscription code, please either sign in with a Parent Account
						or sign out.
					</div>
					<div className={styles.buttonsContainerVertical}>
						<button
							className={styles.primaryButton}
							onClick={this.switchToParent}
						>
							Sign In As A Parent
						</button>
						<button
							className={styles.secondaryButton}
							onClick={() => {
								if (isStudent) {
									window.location.href = URLMake.forHome();
								} else {
									window.location.href = URLMake.forOffice();
								}
							}}
						>
							<ArrowLeft /> Return to Beast Academy Online
						</button>
					</div>
					<div className={styles.bodyText}>
						Questions? Contact us at{" "}
						<a href="mailto:info@beastacademy.com" className={styles.link}>
							info@beastacademy.com
						</a>
						.
					</div>
				</div>
			);
		},

		renderContent: function() {
			const {cart, user, step, account} = this.props;
			let content, progressTracker;
			//TODO we might need to update this to check platform
			const isParent = OpsUser.hasParentRole(this.props.user);
			const isLoggedIn = OpsUser.isLoggedIn(this.props.user);
			const isPlatformGuest = OpsUser.isPlatformGuest(this.props.user);
			const isRestrictedPlatformUser = OpsUser.isRestrictedPlatformUser(user);

			if (
				isLoggedIn &&
				!isParent &&
				!(isPlatformGuest && !isRestrictedPlatformUser)
			) {
				// When user is logged in but not as a parent
				content = this.renderNonParentContent();
			} else {
				const sectionEls = {
					code: RedeemSubscriptionCode,
					account: RedeemSubscriptionAccount,
					studentsLoggedIn: RedeemSubscriptionStudentsLoggedIn,
					studentsLoggedOut: RedeemSubscriptionStudentsLoggedOut,
					review: RedeemSubscriptionReview,
					confirmation: RedeemSubscriptionConfirmation,
				};

				const MainType = sectionEls[step];

				content = (
					<MainType
						account={account}
						cart={cart}
						user={user}
						dispatch={this.props.dispatch}
						setSection={this.setSection}
						onContinue={() => this.nextSection()}
						onGoBack={() => this.previousSection()}
						onRestartFlow={() => this.restartFlow()}
					/>
				);

				if (!isParent) {
					const stepIndex = this.state.steps.indexOf(step);
					// Don't show progress for first (code) or last (confirmation) steps
					const shouldShowProgress =
						stepIndex > 0 && stepIndex < this.state.steps.length - 1;
					if (shouldShowProgress) {
						progressTracker = (
							<div className={styles.progressTracker}>
								Step {stepIndex} of {this.state.steps.length - 2}:
							</div>
						);
					}
				}
			}
			return (
				<div
					className={styles.main}
					data-step={step}
					data-redeem-status={
						this.state.codeSuccessfullyUsed ? "success" : "default"
					}
					data-user-type={isParent ? "existing-parent" : "new-parent"}
				>
					<div className={styles.mainContent} data-step={step}>
						<div className={styles.backgroundImgContainer}>
							<div
								className={styles.backgroundImgDefault}
								role="img"
								aria-label="Decorative background image from the Beast Academy universe"
							/>
						</div>
						<div className={styles.contentContainer}>
							{progressTracker}
							{content}
						</div>
					</div>
				</div>
			);
		},

		requestUserLoad: function() {
			this.props.dispatch({
				type: AT.LOAD_USER_REQUEST,
			});
		},

		render: function() {
			let contentWithGuard = null;
			let guardList = [];
			const {user, account} = this.props;
			if (OpsUser.hasParentRole(user) && account) {
				guardList = [
					{
						identifier: "parentAccountSubs",
						status: account,
						requestLoad: this.loadParentAccount,
					},
				];
			} else if (
				user.load !== "done" &&
				user.load !== "error" &&
				!OpsUser.isDefinitelyNotLoggedIn(user)
			) {
				// Only wait while auth is still resolving. Logged-out visitors end
				// with load "error" / notLoggedIn — treating that as "not done"
				// left MultiLoadGuard on a spinner forever (#6755).
				guardList = [
					{
						identifier: "platformUser",
						status: user,
						requestLoad: this.requestUserLoad,
					},
				];
			}
			contentWithGuard = (
				<MultiLoadGuard
					guardList={guardList}
					loadingView={"logo"}
					logoColorType="blue"
					errorView={this.renderContent()}
					renderLoaded={this.renderContent}
				/>
			);
			const initialLoadingDiv = (
				<div className={styles.mainLoading}>
					<div className={styles.loadingContainer}>
						<LoadingCircle />
					</div>
				</div>
			);

			return (
				<InitRenderSwitch forFirstRender={initialLoadingDiv}>
					{contentWithGuard}
				</InitRenderSwitch>
			);
		},
	})
);
